import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query ActivitySearchResult($searchQuery: SearchQueryInput!) {
  interactionsSearch(searchQuery: $searchQuery) {
    activities {
      id
      siebelId
      channel {
        identifier
        type
        name
        id
      }
      requestType {
        id
      }
      case {
        id
        name
        description
      }
      customer {
        id
        fullName
      }
      operator {
        id
        fullName
      }
      duration
      messagesCount
      vote {
        ratingQuality
        ratingSpeed
        comment
      }
      requestTypeId
      insertedAt
      state
      team {
        id
      }
    }
    terms
    totalCount
    pageSize
  }
}`;

function searchActivities(searchQuery) {
  return apollo.client.query({
    variables: { searchQuery },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.interactionsSearch);
}

export default searchActivities;
